import { PASSORD_MAX_CHARACTERS } from '../constants';
export const uiStrings = [
  // cy - index 0
  {
    lang: 'cy',
    langText: 'Cymraeg',
    langTextSwitch: 'English',
    watch: 'Gwylio',
    watching: 'Gwylio',
    watchingNoHistory: 'Nid oes unrhyw raglenni yn eich rhestr Wylio',
    watchingContinue: 'Parhau i Wylio',
    watchingForProfile: 'Parhau i wylio ar gyfer ',
    myListNoHistory: 'Nid oes unrhyw raglenni yn eich rhestr',
    myListDeleteSuccessPrepend: 'Mae',
    myListDeleteSuccess: "wedi ei ddileu o'ch rhestr",
    home: 'Hafan',
    myS4c: 'Fy S4C',
    profiles: 'Proffiliau',
    watchLive: 'Gwylio yn fyw',
    catchUp: 'Dal i Fyny',
    tvSchedule: 'Amserlen Teledu',
    categories: 'Categorïau',
    allCategories: 'Holl gategorïau',
    search: 'Chwilio',
    searchLabel: 'Chwilio S4C Clic',
    searchPageTitle: 'Chwilio am raglenni ar Clic',
    noSearchResults: 'Dim canlyniadau ar gyfer ',
    searchResultsTitle: ' canlyniad ar gyfer ',
    fullresultsLabel: 'Canlyniadau Llawn',
    menu: 'Dewisiadau',
    featuredProgrammes: 'Rhaglenni newydd heddiw',
    onNext: 'Nesaf',
    website: 'Gwefan',
    moreLikeThis: 'Mwy fel hyn',
    moreLike: 'Mwy fel',
    addToList: 'Ychwanegu at y rhestr',
    removeFromList: 'Tynnwch oddi ar y rhestr',
    remove: 'Tynnwch',
    like: 'Hoffi',
    autoplayNextProgramme: 'Chwarae’r rhaglen nesaf',
    share: 'Rhannu',
    hour: 'awr',
    minutes: 'munud',
    expiresIn: 'Dod i ben mewn',
    days: 'diwrnod',
    allEpisodesOf: 'Pob pennod',
    parentalControl: 'Rheolaeth rhieni',
    help: 'Help',
    howToWatch: 'Sut i wylio S4C',
    howToWatchLink:
      '//www.s4c.cymru/cy/gwasanaethau-mynediad/page/5865/sut-i-dderbyn-s4c-digidol/',
    s4cHome: 'Hafan S4C',
    s4cHomeLink: '//www.s4c.cymru/cy/',
    explore: 'Pori',
    exploreS4c: 'Pori S4C',
    exploreS4cLink: '//www.s4c.cymru/cy/pori/',
    listings: 'Amserlenni',
    listingsLink: '//www.s4c.cymru/c_listings.shtml',
    searchS4c: 'Chwilio S4C',
    searchS4cLink: '//www.s4c.cymru/search/c_index.shtml',
    aboutThisSite: 'Y Wefan hon',
    aboutThisSiteLink: '//www.s4c.cymru/cy/y-wefan-hon/',
    accessibility: 'Hygyrchedd',
    accessibilityLink: '//www.s4c.cymru/cy/y-wefan-hon/page/16703/hygyrchedd/',
    privacyPolicy: 'Polisi preifatrwydd',
    privacyPolicyLink:
      '//www.s4c.cymru/cy/y-wefan-hon/page/16717/polisi-preifatrwydd/',
    cookies: 'Cwcis',
    cookiesLink: '//www.s4c.cymru/cy/y-wefan-hon/page/16711/cwcis/',
    termsConditions: 'Telerau ac Amodau',
    termsConditionsLink:
      '//www.s4c.cymru/cy/y-wefan-hon/page/16706/telerau-ac-amodau/',
    aboutS4c: 'Amdanom ni',
    aboutS4cLink: '//www.s4c.cymru/cy/amdanom-ni/',
    s4cAuthority: 'Bwrdd Unedol S4C',
    s4cAuthorityLink:
      '//www.s4c.cymru/cy/amdanom-ni/page/31316/bwrdd-unedol-s4c/',
    diversity: 'Amrywiaeth a Chynhwysiant',
    diversityLink:
      '//www.s4c.cymru/cy/amdanom-ni/awdurdod/page/17274/polisau-cynlluniau-a-chanllawiau/',
    s4cAdvertising: 'Hysbysebu ar S4C',
    s4cAdvertisingLink: '//www.s4c.cymru/cy/hysbysebu-ar-s4c/',
    jobs: 'Swyddi',
    jobsLink: '//www.s4c.cymru/cy/swyddi/',
    takePart: 'Cymryd rhan',
    takePartLink: 'https://www.s4c.cymru/cy/cymryd-rhan/',
    contactUs: 'Cysylltu â Ni',
    contactUsLink: '//www.s4c.cymru/cy/cysylltu--ni/',
    firstAiredOn: 'Darlledwyd ar',
    lastAiredOn: 'Darlledwyd diwethaf ar',
    programmeDetails: 'Manylion y rhaglen',
    loading: 'Llwytho...',
    sorryLoading: "Mae'n ddrwg gennym! Roedd gwall wrth lwytho'r dudalen",
    azSearch: 'Rhaglenni A-Y',
    genres: 'Genres',
    kids: 'Plant',
    teens: 'Arddegau',
    fullListings: 'Amserlenni llawn',
    live: 'Yn fyw',
    onNow: 'Ymlaen nawr',
    onLater: 'Ymlaen wedyn',
    unavailable: 'Dim ar gael',
    now: 'Nawr',
    invalidEmail: 'Cyfeiriad e-bost annilys',
    emailDontMatch: 'Nid yw’r e-byst yn cyfateb',
    required: 'Angenrheidiol',
    email: 'Cyfeiriad e-bost',
    emailConfirm: 'Cadarnhau e-bost',
    socialEmail: 'Ebost',
    password: 'Cyfrinair',
    accountPassword: 'Cyfrinair cyfrif',
    logIn: 'Mewngofnodi',
    forgotPassword: 'Wedi anghofio eich cyfrinair?',
    loginHead: "Mewngofnodwch i'ch cyfrif",
    signUp: 'Cofrestru',
    register: 'Cofrestru',
    loginInstruction: 'Rheoli gosodiadau a thanysgrifiadau eich cyfrif.',
    loginInstructionForce:
      'Erbyn hyn mae angen i chi gofrestru i wylio ein cynnwys. Os nad oes gennych gyfrif eto, yn syml ',
    loginInstructionNew: 'Heb gyfrif Fy S4C?',
    registerInstruction: 'Cam 1 o 2',
    registerInstruction2: 'Cam 2 o 2',
    yourName: 'Eich enw',
    firstOrFullName: 'Enw cyntaf neu enw llawn',
    yes: 'Ydw',
    no: 'Nac ydw',
    registerConfirm:
      "Rwyf wedi darllen a chytuno â thelerau <a href='https://www.s4c.cymru/cy/y-wefan-hon/page/16717/polisi-preifatrwydd/' target='_blank'>Polisi Preifatrwydd S4C</a> a <a href='https://www.s4c.cymru/cy/y-wefan-hon/page/16711/cwcis/' target='_blank'>Pholisi Cwcis S4C</a>",
    dataPromise: 'Addewid data:',
    dataPromiseMsg:
      'Rydym yn cydnabod bod angen ymdrin â’ch manylion personol yn ofalus. Ni fyddwn byth yn trosglwyddo eich manylion i unrhyw un heb eich caniatâd a byddwn yn esbonio’n glir sut i derfynu eich tanysgrifiad pob tro y byddwn yn cysylltu â chi. Sylwer bod angen i chi fod dros 16 oed i danysgrifio.',
    signUpCTA:
      'Cofrestrwch i gael mynediad at gynnwys sydd wedi ennill gwobrau – yn rhad ac am ddim',
    signUpCTABtn: 'Cofrestrwch yn rhad ac am ddim',
    signUpSuccess:
      'Byddwch yn derbyn neges e-bost yn cynnwys dolen i gadarnhau eich cyfeiriad e-bost ac i actifadu eich cyfrif.<br/><br/>Os nad ydych chi’n derbyn neges e-bost, edrychwch yn eich ffolderi e-bost sbam a sbwriel. ',
    thankYou: 'Diolch',
    verifyAccount: 'Cadarnhau eich cyfrif',
    verifyInstruct:
      'Bron â gorffen, yr oll sydd angen i chi ei wneud yw gosod cyfrinair ar gyfer  ',
    choosePassword: 'Dewiswch gyfrinair',
    confirmPassword: 'Cadarnhau eich cyfrinair',
    receiveUpdates:
      'Derbyniwch ein diweddariadau dros e-bost er mwyn clywed am raglenni a gwasanaethau S4C a chael cyfle i rannu eich barn.',
    firstToHear:
      'Byddwch ymysg y cyntaf i glywed am nodweddion newydd ar ein platfformau.',
    completeSignUp: 'Cwblhau’r broses gofrestru',
    s4cPolicies:
      "<a href='https://www.s4c.cymru/cy/y-wefan-hon/page/16717/polisi-preifatrwydd/' target='_blank'>Polisi Preifatrwydd S4C </a> a <a href='https://www.s4c.cymru/cy/y-wefan-hon/page/16711/cwcis/' target='_blank'>Pholisi Cwcis S4C</a>",
    match: 'Nid yw’r cyfrineiriau yr un fath',
    passwordLength: 'Rhaid i gyfrineiriau fod dros 6 nod',
    notes: 'Nodiadau',
    myList: 'Fy rhestr',
    myListForProfile: 'Rhestr',
    accountSettings: 'Gosodiadau’r cyfrif',
    signOut: 'Allgofnodi',
    logOut: 'Allgofnodi',
    account: 'Cyfrif',
    communications: 'Cyfathrebu',
    changeEmail: 'Newid cyfeiriad e-bost',
    changePassword: 'Newid cyfrinair',
    signOutAll: 'Allgofnodi ar bob dyfais',
    deleteAccount: 'Dileu’r cyfrif hwn',
    postCode: 'Cod post',
    prefLanguage: 'Dewis iaith',
    gender: 'Rhywedd',
    dob: 'Dyddiad geni',
    updateDetails: 'Diweddaru eich manylion',
    addDetails: 'Ychwanegwch eich manylion',
    name: 'Enw',
    male: 'Gwrywaidd',
    female: 'Benywaidd',
    other: 'Arall',
    preferNot: 'Gwell gen i beidio â dweud',
    invalidPostCode: 'Cod post annilys',
    selectString: 'Dewis',
    welsh: 'Cymraeg',
    english: 'Saesneg',
    invalidDOB: 'Dyddiad geni annilys, defnyddiwch fformat DD/MM/BBBB',
    readMore: 'Darllen mwy',
    confirmSignOut: 'Ydych chi’n siŵr eich bod chi eisiau allgofnodi?',
    cancel: 'Canslo',
    confirmSignOutAll:
      'Ydych chi’n siŵr eich bod chi eisiau allgofnodi ar bob dyfais?',
    signOutAllShort: 'Allgofnodi ar bob dyfais',
    passwordRequired: 'Angen cyfrinair',
    deleteThisAcc: 'Dileu’r cyfrif hwn',
    deleteThisProf: 'Dileu’r proffil hwn',
    confirmDeleteAcc:
      'Ydych chi’n siŵr eich bod chi eisiau dileu’r cyfrif hwn?',
    confirmDeleteProf:
      'Ydych chi’n siŵr eich bod chi eisiau dileu’r proffil hwn?',
    changeEmailAddress: 'Newid cyfeiriad e-bost',
    currentEmail: 'Cyfeiriad e-bost presennol',
    newEmail: 'Cyfeiriad e-bost newydd',
    currentPassword: 'Cyfrinair presennol',
    updateEmail: 'Diweddaru e-bost',
    verifyingPlease: 'Cadarnhau cyfeiriad e-bost, arhoswch.',
    verifyingEmailMessage:
      "Diolch am gymryd yr amser i gadarnhau eich cyfeiriad e-bost.<br> Mae eich cofrestriad gyda Fy S4C bellach wedi'i gwblhau.",
    pleaseLogin:
      "<a href='/MyS4C/SignIn'>Mewngofnodwch</a> eto gyda’r cyfeiriad e-bost newydd.",
    verifyEmail: 'Cadarnhau cyfeiriad e-bost',
    emailSoon:
      'Byddwch yn derbyn neges e-bost yn cynnwys dolen i gadarnhau eich cyfeiriad e-bost ac actifadu eich cyfrif. ',
    updateSuccess: 'Wedi llwyddo i ddiweddaru',
    addSuccess: 'Ychwanegu llwyddiant',
    emailResetPassword:
      'Byddwch yn derbyn neges e-bost yn cynnwys cyfarwyddiadau ar sut i ailosod eich cyfrinair',
    newPassword: 'Cyfrinair newydd',
    updatePassword: 'Diweddaru cyfrinair',
    updatePasswordSuccess: 'Wedi llwyddo i ddiweddaru eich cyfrinair',
    problemCompleting:
      'Cododd problem wrth gwblhau’r weithred hon, rhowch gynnig arall arni',
    communicationPreferences: 'Dewisiadau cyfathrebu ',
    updatePreferences: 'Diweddaru dewisiadau',
    availability: 'Argaeledd',
    shareEmail: 'Rhannu ar Ebost',
    shareFacebook: 'Rhannu ar Facebook',
    shareTwitter: 'Rhannu ar Twitter',
    shareWhatsapp: 'Rhannu ar WhatsApp',
    close: 'Cau',
    resetMyPassword: 'Ailosod fy nghyfrinair',
    forgottenPassword: 'Wedi anghofio fy nghyfrinair',
    forgotPasswordIntstruct:
      'Nodwch eich cyfeiriad e-bost a byddwn yn anfon rhagor o gyfarwyddiadau i chi. ',
    playerErrorDetected: 'Gwall',
    adBlockerDetected: 'Rhybudd rydym wedi canfod rhwystr hysbysebion',
    adBlockerMsg1:
      "Analluoga'ch atalydd ad ac adnewyddwch y dudalen hon i weld ein cynnwys.",
    adBlockerMsg2: "Cofiwch fod refeniw hysbysebu'n mynd tuag at greu cynnwys.",
    playAnyway: 'Parhau',
    notAutoplayNextProgramme: "Peidiwch â awtomeiddio'r rhaglen nesaf",
    todaysHighlights: 'Uchafbwyntiau Heddiw',
    yesterdaysHighlights: 'Uchafbwyntiau Ddoe',
    yesterday: 'Ddoe',
    highlights: 'Uchafbwyntiau',
    morning: 'Bore',
    afternoon: 'Prynhawn',
    evening: 'Nos',
    todayAt: 'Heddiw am',
    today: 'Heddiw',
    at: 'am',
    tonightAt: 'Heno am',
    showMore: 'Dangos mwy',
    allGenres: 'Pob genre',
    OurChannelForKids: 'Ein gwasanaeth i blant meithrin',
    programmesForTeenagers: 'Rhaglenni i blant 7-13 oed',
    notAvailable: 'Ddim ar gael',
    next: 'Nesa',
    recommended: 'Ein awgrymiadau ni',
    enterFour: 'Teipiwch PIN 4 digid',
    confirmPin: 'Cadarnhewch eich PIN',
    askForPin: 'Gofyn am eich PIN ar gyfer pob rhaglen sydd â rhybudd cynnwys?',
    emailAddress1: 'Cyfeiriad e-bost',
    emailAddress2:
      '(cael ei ddefnyddio i anfon eich PIN atoch os byddwch yn ei anghofio)',
    enableParent: 'Galluogi rheolaeth rhieni',
    disableParent: 'Analluogi rheolaeth rhieni',
    setPin: 'Gosod pin',
    removePin: "Tynnu'r pin",
    parentNotSet:
      '<p><b>Nid yw rheolaeth rhieni wedi’i gosod ar hyn o bryd.</b> Mae hyn yn golygu y gall unrhyw un sy’n defnyddio’r porwr hwn weld rhaglenni a all fod â chynnwys sy’n anaddas i blant.</p><p>Gallwch atal hyn trwy osod PIN sy’n eich galluogi i reoli’r gosodiadau rheolaeth rhieni ar gyfer y cyfrif hwn.</p><p>Os bydd wedi cael ei alluogi, byddwn yn gofyn i chi deipio PIN bob tro y bydd y cyfrif hwn yn gwylio rhaglen sydd â rhybudd cynnwys. Os bydd rheolaeth rhieni wedi’i diffodd, ni fydd angen i chi deipio PIN bob tro os ydych chi dros 16 oed.</p>',
    noMatchPins: 'Nid yw’r PIN yr un fath',
    pinFour: 'Rhaid i’r PIN fod â 4 digid',
    digit1: 'Digid cyntaf y PIN',
    digit2: 'Ail ddigid y PIN',
    digit3: 'Trydydd digid y PIN',
    digit4: 'Pedwerydd digid y PIN',
    newDigit1: 'Digid cyntaf y PIN newydd',
    newDigit2: 'Ail ddigid y PIN newydd',
    newDigit3: 'Trydydd ddigid y PIN newydd',
    newDigit4: 'Pedwerydd digid y PIN newydd',
    confDigit1: 'Cadarnhau digid cyntaf y PIN ',
    confDigit2: 'Cadarnhau ail ddigid y PIN',
    confDigit3: 'Cadarnhau trydydd digid y PIN',
    confDigit4: 'Cadarnhau pedwerydd digid y PIN',
    on: 'Ymlaen',
    off: 'I ffwrdd',
    parentSetOn: 'Mae rheolaeth rhieni wedi’i galluogi ar hyn o bryd.',
    parentSetOnDesc:
      'Byddwn yn gofyn i chi deipio PIN bob tro y bydd y cyfrif hwn yn gwylio rhaglen sydd â rhybudd cynnwys.',
    parentSetOff: 'Mae rheolaeth rhieni wedi’i diffodd ar hyn o bryd.',
    parentSetOffDesc:
      'Ni fydd angen i chi deipio PIN pan fydd y cyfrif hwn yn gwylio rhaglen sydd â rhybudd cynnwys.',
    parentControlSettings: 'Gosodiadau rheolaeth rhieni',
    yourPin: 'Eich PIN',
    updateParentControl: 'Diweddaru rheolaeth rhieni',
    changePin: 'Newid eich PIN',
    yourCurrentPin: 'Eich PIN presennol',
    enterPin: 'Rhowch eich PIN i mewn',
    enterNewPin: 'Teipiwch PIN newydd',
    confirmNewPin: 'Cadarnhewch eich PIN newydd',
    updatePin: 'Diweddarwch eich PIN',
    forgottenPin: 'Wedi anghofio eich PIN?',
    incorrectPin: 'Nid yw’r PIN hwn yn cyfateb',
    pinChangeSuccess: 'Wedi llwyddo i newid eich PIN',
    contentWarning: 'Rhybudd Cynnwys',
    contentWarningTitle: 'Rhybudd Cynnwys',
    contentWarningChallenge:
      'Cadarnhewch eich bod yn ddigon hen i wylio’r rhaglen hon.',
    contentWarningConfirm: 'Ydw, rydw i dros 16 oed.',
    contentWarningChallengePin: 'Teipiwch eich rhif PIN i weld y rhaglen.',
    ok: 'Iawn',
    not16: 'Anaddas i blant',
    parentalUpdated: 'Mae rheolaeth rhieni wedi cael ei diweddaru',
    feedBackAlert:
      'Diolch am roi cynnig ar fersiwn beta Clic. Os oes gennych unrhyw adborth, anfonwch neges e-bost atom ar',
    feedBackSubject: 'Adborth Beta Clic',
    dismiss: 'Cau',
    metaSiteName: 'S4C',
    metaTitle: 'S4C Clic',
    metaUrl: 'https://www.s4c.cymru/clic',
    metaDescription:
      'S4C Clic: Y cynnwys diweddaraf, bocs sets o’r archif, chwaraeon byw, ac amrywiaeth o raglenni.',
    metaTwitter: '@s4c',
    signedVersion: 'Fersiwn iaith arwyddo',
    about: 'About',
    privacy: 'Polisi Preifatrwydd',
    aboutThisApp: 'Am yr app hwn',
    appVersion: 'Rhif yr App',
    resetPIN:
      'For instructions to reset your PIN, please contact our hotline on 0370 600 4141 (Calls cost no more than a national rate call to an 01 or 02 number) or email us at gwifren@s4c.cymru.',
    programmes: 'Rhaglenni',
    selectProfileImg: 'Dewiswch delwedd y proffil',
    isChildAccount: 'Cyfrif plentyn',
    edit: 'Golygu',
    add: 'Ychwanegu',
    profileSetSuccess: "Y proffil gweithredol cyfredol wedi'i ddiweddaru i",
    profileDeleteSuccess: "Proffil wedi'i ddileu",
    manageProfiles: 'Rheoli eich proffil',
    addProfile: 'Ychwanegu proffil',
    mainAccountText: 'Dyma’r prif gyfrif',
    hi: 'Helo',
    boxSets: 'Bocs Set',
    episodesAvailable: 'Episodau ar gael',
    episodes: 'pennod',
    englishSubtitles: 'Isdeitlau Saesneg ar gael',
    welshSubtitles: 'Isdeitlau Cymraeg ar gael',
    welshEnglishSubtitles: 'Isdeitlau Cymraeg a Saesneg ar gael',
    onlineExclusives: 'Cynnwys ar-lein yn unig',
    onlineExclusive: 'Cynnwys ar-lein yn unig',
    success: 'Llwyddiant',
    successfullyDeleted1: "Mae'ch cyfrif wedi cael ei ddileu yn llwyddiannus.",
    successfullyDeleted2:
      "Mae'n ddrwg gennym eich gweld chi! Os oes unrhyw beth y gallem fod wedi'i wneud yn well, byddai'n wych pe gallech roi gwybod i ni. Rydym bob amser yn edrych i wella.",
    sendFeedback: 'Anfon adborth',
    feedbackURL: 'https://www.s4c.cymru/c_contact.shtml',
    mailingLists: [
      'I dderbyn diweddariadau ar e-bost er mwyn dysgu am raglenni a gwasanaethau S4C a chael cyfle i leisio barn.',
      'Byddwch ymhlith y cyntaf i ddysgu am eitemau newydd',
    ],
    choosePast: 'Dewiswch ddyddiad yn y gorffennol',
    moreFromS4C: 'Eisiau mwy allan o S4C Clic?',
    signUpNow: 'Cofrestrwch nawr',
    editProfile: 'Golygu proffil',
    dobPlaceHolder: 'DD/MM/BBBB',
    alreadyRegistered: 'Eisoes wedi cofrestru?',
    tryCat: "Beth am wylio rhywbeth allan o un o'n categorïau",
    genericError: "Mae'n ddrwg gennym, mae gwall wedi digwydd",
    channels: 'Sianelau',
    hanshDesc: 'Tiwns, comedi a lleisiau ffres',
    progSignUpTitle: 'Mae angen i chi fewngofnodi i wylio hyn',
    progSignUpInstruction: 'Ni ddylai gymryd ond ychydig funudau',
    or: 'ne',
    loginIsComing: 'Gwneud y mwyaf o S4C Clic',
    willNeedToLogin:
      'Erbyn 10 Mehefin bydd angen i chi gofrestru i wylio S4C Clic.',
    signingInAllows: 'Cofrestrwch nawr i...',
    createProfiles: 'Greu proffiliau ar gyfer eich teulu',
    createList: 'Greu eich rhestr eich hun o raglenni',
    continueWatching: 'Barhau i wylio rhaglen o’r un man',
    daysToLogin: 'diwrnod i fynd',
    dayToLogin: 'diwrnod i fynd',
    loginToWatch: 'Bydd angen i chi fewngofnodi',
    loginOnce:
      'Ond ‘does ond rhaid chi wneud unwaith i barhau i fwynhau S4C Clic',
    back: 'Yn ôl',
    createAccount: 'Creu cyfrif',
    competitionMessage:
      "Cofrestrwch rhwng Mai 27 ac Awst 10  i gael y cyfle i ennill Teledu Smart, Sgrîn Lydan 49. <a href='https://www.s4c.cymru/cystadleuaeth-clic' target='_blank'>Telerau ac amodau</a>",
    audioDescribed: 'Sain ddisgrifio',
    signed: 'Arwyddo',
    otherCommsVailable: 'English commentary is available for this event',
    learnersChannel: 'Dysgwyr',
    learnersDesc: 'Rhaglenni i ddysgwyr Cymraeg',
    walterChannel: 'Walter Presents',
    walterDesc: 'Ar gyfer S4C',
    podcasts: 'Podlediadau',
    manageList: 'Rheoli rhestr',
    SignUpForLatest: 'Cofrestrwch ar gyfer y newyddion diweddaraf gan S4C',
    deeplLinkLabel: 'Defnyddiwch drwy app',
    didYouMean: 'A’i dyma oedd gen ti mewn golwg',
    didYouMeanQ: "Oeddech chi'n golygu?",
    updateYourDetails: 'Diweddarwch eich manylion',
    moreDataMsg1:
      'Er mwyn ein galluogi i wella safon S4C Clic, rydym angen ychydig o fanylion amdanoch.',
    moreDataMsg2:
      'Ni fyddwn yn rhannu’r manylion gydag unrhyw un arall – rydym am sicrhau ein bod yn cynnig y rhaglenni gorau i chi, a’u bod ar gael pan fyddwch eisiau eu gwylio.',
    code: 'Cod',
    connect: 'Cysylltu',
    connectTV: 'Cysylltwch eich cyfrif gyda’ch teledu',
    enterTVCode: 'Mewnbynwch eich cod fel y dangosir ar eich teledu',
    successTVCode: 'Sicrhewch fod eich cod yn ddilys',
    invalidCode: 'Rhowch god dilys os gwelwch yn dda',
    catchUpInValidDate: 'Nid oes unrhyw raglenni ar gyfer y dyddiad hwn.',
    whosWatching: "Pwy sy'n gwylio?",
    day: 'Dydd',
    month: 'Mis',
    year: 'Blwyddyn',
    dd: 'dd',
    mm: 'mm',
    yyyy: 'bbbb',
    searchLookingFor: "Os ydych chi'n chwilio am",
    searchYouMighLike: ' y fyddech efallai yn hoffi...',
    searchYouMighLikeFrom: ', efallai yr hoffech rywbeth arall o',
    searchAll: 'Pob rhaglen',
    searchProgrammes: '',
    hereForYou: 'Calendr Adfent Clic',
    hereForYouDesc: 'Anrheg Nadolig i chi o S4C',
    suggestions: 'Awgrymiadau',
    lookingFor: "Ydych chi'n edrych am",
    tryACategory: 'Neu pam ddim edrych ar ein categorïau',
    whereShare: 'Ble hoffech chi rannu’r cynnwys yma?',
    theme: 'Thema',
    light: 'Golau',
    dark: 'Tywyll',
    currentTheme: 'Thema gyfredol',
    searchClic: 'Chwilio ar draws Clic',
    optional: 'Dewisol',
    appearance: 'Golwg',
    viewAll: 'Gweld y cwbl',
    error404: 'Gwall 404',
    error404CantFindPage: `Sori, ni methu dod o hyd i'r dudalen.`,
    error404Desc: `Dim angen poeni, ewch i weld ein categorïau a darganfod cynnwys byddwch chi'n caru`,
    error404BrowseCategories: 'Pori ein categorïau',
    error404TakeMeHome: `Nôl i'r Hafan`,
    moreDetails: 'Mwy o wybodaeth',
    closeDetails: 'Llai o wybodaeth',
    keyboardShortcuts: 'Byrlwybr teipio',
    toggleWelsh: 'Toglo Isdeitlau Cymraeg ymlaen/i ffwrdd',
    toggleEnglish: 'Toglo Isdeitlau Saesneg ymlaen/i ffwrdd',
    skip5Sec: 'Neidio yn ôl 5 eiliad',
    fastForward5Sec: 'Neidio ymlaen 5 eiliad',
    pauseVideo: `Cymryd saib o'r fideo`,
    followS4CFacebook: 'Dilynwch S4C ar Facebook am fwy o gynnwys',
    followS4CInstagram: 'Dilynwch S4C ar Instagram am fwy o gynnwys',
    followS4CTwitter: 'Dilynwch S4C ar Twitter am fwy o gynnwys',
    followS4CYoutube: 'Gwyliwch mwy o gynnwys gan S4C ar YouTube',
    profileDropdown: 'Dewislen proffil',
    profileAvatar: 'Afatar proffil',
    metaDescriptionBoxsets:
      'O hen gyfresi a ffilmiau i gyfresi newydd sbon, mae yna bocs sets i bawb fan hyn.',
    metaDescriptionCategories:
      'Chwaraeon, drama, adloniant a mwy – gwyliwch gynnwys ar draws amryw o gategorïau.',
    metaDescriptionCatchUp:
      'Heb gael cyfle i wylio cyfres, ffilm neu bennod eto? Dyma’r lle i ddal i fyny ar gynnwys diweddar.',
    metaDescriptionLive:
      'Gwyliwch gynnwys S4C yn fyw fan hyn – o chwaraeon byw i gynnwys Cyw.',
    metaDescriptionSearch:
      'Methu dod o hyd i’r cynnwys oeddech chi am wylio? Chwiliwch am fwy o gynnwys fan hyn.',
    nowAndNext: 'Nawr a nesaf',
    popular: 'Poblogaidd',
    trending: 'Trendio',
    topPicks: 'I chi',
    ourPicks: 'Ein pigion',
    popularThisWeek: 'Poblogaidd wythnos yma',
    trendingNow: 'Trendio nawr',
    contentUnsuitableForChildren:
      "Nid yw'r cynnwys yma yn addas i gyfrif plentyn.",
    upNext: 'Nesa',
    play: 'Chwarae',
    playingIn: 'Chwarae mewn',
    seconds: ' eiliad',
    expired: 'Wedi dod i ben',
    streamNotFound: "Sori, nid yw'r ffrwd yma ar gael.",
    expires: 'Yn dod i ben',
    streamNotAvailableForCatchUp: 'Nid yw’r ffrwd ar gael i ddal i fyny',
    streamNoLongerAvailableForCatchUp:
      'Nid yw’r ffrwd ar gael bellach i ddal i fyny',

    // Error messages from MyS4C.pl
    '00000': "Mae'r cyfeiriad e-bost neu'r cyfrinair yn anghywir",
    '00001': "Mae'r cyfrif wedi cloi dros dro. Ceisiwch eto nes ymlaen",
    '00002': 'Mae gwybodaeth bwysig ar goll',
    '00003': 'cy__',
    '00004':
      "Sori, mae'r system yn cael ei diweddaru ar hyn o bryd. Fel arfer, bydd hyn wedi ei orffen mewn ychydig funudau. Cysylltwch â ni os yw'r broblem yn parhau",
    '00005': "Nid yw'r cyfeiriad e-bost yn ddilys",
    '00006':
      'Rydych chi wedi gofyn i ni beidio anfon e-byst at y cyfeiriad yma. Yn anffodus mae hyn yn golygu nad oes modd i chi gofrestru ar gyfer FyS4C. Os ydych chi eisiau newid hyn, cysylltwch â Gwifren Gwylwyr ar 0370 600 4141',
    '00007': "Mae'r cyfeiriad e-bost yma yn cael ei ddefnyddio yn barod.",
    '00008':
      "Mae''r cyfrif yma''n cael ei ddileu ar hyn o bryd, ond mi fydd modd i chi gofrestru eto cyn hir",
    '00009':
      'Am eich bod chi wedi gofyn i ni beidio anfon e-byst at y cyfeiriad yma, does dim modd i chi danysgrifio i dderbyn y cylchlythyr yma. Os ydych chi eisiau newid hyn, cysylltwch â Gwifren Gwylwyr ar 0370 600 4141',
    '00010': "Mae'n rhaid i'r cyfrinair gynnwys o leiaf 6 nod",
    '00011': "Nid yw'r cyfrinair yr un peth",
    '00012':
      "Mae rhywbeth wedi mynd o'i le. <a href='/MyS4C/SignUp'>Dechrau eto.</a>",
    '00013': "Mae'r cyfrif wedi cloi dros dro. Ceisiwch eto nes ymlaen",
    '00014':
      "Roedd yna broblem. <a href='/MyS4C/SignIn'>Mewngofnodwch eto os gwelwch yn dda.</a>",
    '00015': "Mae'r cyfrif wedi cloi",
    '00016': "Mae angen i chi wirio'r cyfrif",
    '00017': "Dydyn ni ddim yn gallu dod o hyd i'r cyfrif yma.",
    '00018':
      "Roedd problem wrth fewngofnodi ar y ddyfais hon. <a href='/MyS4C/SignIn'>Mewngofnodwch eto os gwelwch yn dda.</a>",
    '00019':
      "Mae'r sesiwn wedi dod i ben, <a href='/MyS4C/SignIn'>Mewngofnodwch eto os gwelwch yn dda.</a>",
    '00020': 'cy_',
    '00021': 'cy_',
    '00022': 'cy_',
    '00023': 'cy_',
    '00024':
      "Os ydych chi'n dymuno rhoi eich dyddiad geni, yna mae'n rhaid cynnwys y diwrnod, y mis a'r flwyddyn",
    '00025': 'Dyddiad geni annilys',
    '00026': 'cy_',
    '00027': 'Mae angen i chi roi cyfeiriad e-bost',
    '00028': "Nid yw'r cyfeiriad e-bost yma yn gywir",
    '00029': "Mae'r cyfeiriad e-bost yma yn cael ei ddefnyddio yn barod",
    '00030':
      "Mae rhywbeth wedi mynd o'i le wrth wirio eich cyfeiriad e-bost. <a href='/MyS4C/SignIn'>Ceisiwch eto.</a>",
    '00031':
      "Sori. Dydyn ni ddim wedi gallu dod o hyd i'r cyfeiriad e-bost yma",
    '00032': 'Mae cyfeiriad e-bost a / neu god dilysu yn anghywir.',
    '00033': "Mae'r cyfeiriad e-bost hwnnw wedi'i wirio eisoes.",
    '00034': `Mae'n ddrwg gennym, mae'r cyfrinair yn rhy hir. Ni all fod yn fwy na ${PASSORD_MAX_CHARACTERS} nod`,
    99999: "Mae'r cyfrinair yn anghywir",
    20001: "Nid yw'r proffil yn bodoli",
    20002: "Nid yw'r proffil hwnnw'n bodoli bellach",
    20003: 'Caniateir uchafswm o 10 proffil fesul cyfrif',
    20004:
      "Chewch chi ddim dileu'r proffil hwn gan ei fod yn perthyn i ddeiliad y cyfrif",
    20005: "Nid yw'r cyfrinair newydd a'r cyfrinair cadarnhau yn cyfateb",
    20006:
      "Does dim modd newid y cyfrinair, ydych chi'n siŵr bod y cyfrinair roesoch chi'n gywir?",
    20007: 'Cyfrinair anghywir',
    20008: 'Rhaid dewis proffil yn gyntaf',
    20009: 'Cod ddim ar gael neu efallai ei fod wedi dod i ben',
    30000: 'item_name ddim yn ddilys',
    30001: 'Cod ar goll',
    30002: 'socket_id ar goll',
    30003: 'advertising_id ar goll',

    // Error Messages For Smart TV broadcast
    'We were unable to connect to the device, please try again.':
      'Nid oedd modd cysylltu â’r dyfais, rhowch gynnig arall arni.',
    footerSearch: 'Chwilio am rywbeth arall?',
    footerSearchPlaceholder: 'Chwiliwch am raglen neu gategori',
  },
  // en - index 1
  {
    lang: 'en',
    langText: 'English',
    langTextSwitch: 'Cymraeg',
    watch: 'Watch',
    watching: 'Watching',
    watchingNoHistory: 'There are no programmes in your Watching list.',
    watchingContinue: 'Continue Watching',
    watchingForProfile: 'Continue watching for',
    myListNoHistory: 'There are no programmes in your list',
    myListDeleteSuccessPrepend: '',
    myListDeleteSuccess: 'has been deleted from your list',
    home: 'Home',
    myS4c: 'My S4C',
    profiles: 'Profiles',
    watchLive: 'Watch Live',
    catchUp: 'Catch Up',
    tvSchedule: 'TV Schedule',
    categories: 'Categories',
    allCategories: 'All categories',
    search: 'Search',
    searchLabel: 'Search S4C Clic',
    searchPageTitle: 'Search for programmes on Clic',
    noSearchResults: 'No results for ',
    searchResultsTitle: ' results for ',
    fullresultsLabel: 'Full Results',
    menu: 'Menu',
    featuredProgrammes: 'Today’s featured programmes',
    onNext: 'On Next',
    website: 'Website',
    moreLikeThis: 'More like this',
    moreLike: 'More like',
    addToList: 'Add to list',
    removeFromList: 'Remove from list',
    remove: 'Remove',
    like: 'Like',
    autoplayNextProgramme: 'Autoplay next programme',
    share: 'Share',
    hour: 'hour',
    minutes: 'minutes',
    expiresIn: 'Expires in',
    days: 'days',
    allEpisodesOf: 'All episodes of',
    parentalControl: 'Parental control',
    help: 'Help',
    howToWatch: 'How to watch S4C',
    howToWatchLink:
      '//www.s4c.cymru/en/access-services/page/5865/how-to-get-s4c/',
    s4cHome: 'S4C Home',
    s4cHomeLink: '//www.s4c.cymru/en/',
    explore: 'Explore',
    exploreS4c: 'Explore S4C',
    exploreS4cLink: '//www.s4c.cymru/en/explore/',
    listings: 'Listings',
    listingsLink: '//www.s4c.cymru/e_listings.shtml',
    searchS4c: 'Search S4C',
    searchS4cLink: '//www.s4c.cymru/search/e_index.shtml',
    aboutThisSite: 'About this site',
    aboutThisSiteLink: '//www.s4c.cymru/en/about-this-site/',
    accessibility: 'Accessibility',
    accessibilityLink:
      '//www.s4c.cymru/en/about-this-site/page/16703/accessibility/',
    privacyPolicy: 'Privacy policy',
    privacyPolicyLink:
      '//www.s4c.cymru/en/about-this-site/page/16717/privacy-policy/',
    cookies: 'Cookies',
    cookiesLink: '//www.s4c.cymru/en/about-this-site/page/16711/cookies/',
    termsConditions: 'Terms & conditions',
    termsConditionsLink:
      '//www.s4c.cymru/en/about-this-site/page/16706/terms-and-conditions/',
    aboutS4c: 'About S4C',
    aboutS4cLink: '//www.s4c.cymru/en/about-us/',
    s4cAuthority: 'S4C Unitary Board',
    s4cAuthorityLink: '//www.s4c.cymru/en/about-us/page/31316/unitary-board/',
    diversity: 'Diversity and Inclusion',
    diversityLink:
      '//www.s4c.cymru/en/about-us/authority/page/17274/policies-plans-and-guidelines/',
    s4cAdvertising: 'S4C Advertising',
    s4cAdvertisingLink: '//www.s4c.cymru/en/advertising-on-s4c/',
    jobs: 'Jobs',
    jobsLink: '//www.s4c.cymru/en/jobs/',
    takePart: 'Take part',
    takePartLink: 'https://www.s4c.cymru/en/take-part/',
    contactUs: 'Contact us',
    contactUsLink: '//www.s4c.cymru/en/contact-us/',
    firstAiredOn: 'First aired on',
    lastAiredOn: 'Last aired on',
    programmeDetails: 'Programme details',
    loading: 'Loading...',
    sorryLoading: "Sorry, we're having trouble loading this.",
    azSearch: 'A-Z of programmes',
    genres: 'Genres',
    kids: 'Kids',
    teens: 'Teens',
    fullListings: 'Full listings',
    live: 'Live',
    onNow: 'On now',
    onLater: 'On later',
    unavailable: 'Unavailable',
    now: 'Now',
    invalidEmail: 'Invalid email address',
    emailDontMatch: "Emails don't match",
    required: 'Required',
    email: 'Email address',
    emailConfirm: 'Confirm email address',
    socialEmail: 'Email',
    password: 'Password',
    accountPassword: 'Account password',
    logIn: 'Sign In',
    forgotPassword: 'Forgotten your password?',
    loginHead: 'Sign in to your account',
    signUp: 'Sign up',
    register: 'Register',
    loginInstruction: 'Manage your account settings and subscriptions.',
    loginInstructionForce:
      "You now need to sign in to watch our content. If you don't have an account yet, simply ",
    loginInstructionNew: 'Don’t have a MyS4C account?',
    registerInstruction: 'Step 1 of 2',
    registerInstruction2: 'Step 2 of 2',
    yourName: 'Your name',
    firstOrFullName: 'First or full name',
    yes: 'Yes',
    no: 'No',
    registerConfirm:
      "I have read and agreed to the terms of <a href='https://www.s4c.cymru/en/about-this-site/page/16717/privacy-policy/' target='_blank'>S4C Privacy Policy</a> and <a href='https://www.s4c.cymru/en/about-this-site/page/16711/cookies/' target='_blank'>S4C's Cookies Policy</a>",
    dataPromise: 'Data promise:',
    dataPromiseMsg:
      "We recognise that your personal details need to be treated with care. We'll never pass your details to anyone without your permission and we'll explain clearly how to unsubscribe each time we contact you. Please note that you must be 16 or over to subscribe.",
    signUpCTA: 'Sign up for free access to award winning content',
    signUpCTABtn: 'Sign up for free',
    signUpSuccess:
      "You will receive an email soon with a link to confirm your email address and activate your account.<br/><br/>If you don't receive an email, please check your spam and junk mail folders.",
    thankYou: 'Thank you',
    verifyAccount: 'Verify account',
    verifyInstruct: 'Almost there, just need to set a password for ',
    choosePassword: 'Choose a password',
    confirmPassword: 'Verify your password',
    receiveUpdates:
      "Receive our updates by email to hear about S4C's programmes and services and have your opportunity to share your views.",
    firstToHear: 'Be the first to hear about new features on our platforms.',
    completeSignUp: 'Complete sign up',
    s4cPolicies:
      "<a href='https://www.s4c.cymru/en/about-this-site/page/16717/privacy-policy/' target='_blank'>S4C Privacy Policy</a> and <a href='https://www.s4c.cymru/en/about-this-site/page/16711/cookies/' target='_blank'>S4C's Cookies Policy</a>",
    match: 'Passwords do not match',
    passwordLength: 'Password must be at least 6 characters',
    notes: 'Notes',
    myList: 'My List',
    myListForProfile: "'s List",
    accountSettings: 'Account settings',
    signOut: 'Sign out',
    logOut: 'Log out',
    account: 'Account',
    communications: 'Communications',
    changeEmail: 'Change email',
    changePassword: 'Change password',
    signOutAll: 'Sign out of all devices',
    deleteAccount: 'Delete this account',
    postCode: 'Post code',
    prefLanguage: 'Preferred language',
    gender: 'Gender',
    dob: 'Date of birth',
    updateDetails: 'Update details',
    addDetails: 'Add details',
    name: 'Name',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    preferNot: 'Prefer not to say',
    invalidPostCode: 'Invalid post code',
    selectString: 'Select',
    welsh: 'Welsh',
    english: 'English',
    invalidDOB: 'Invalid date of birth please use the format DD/MM/YYYY',
    readMore: 'Read more',
    confirmSignOut: 'Are you sure you want to sign out?',
    cancel: 'Cancel',
    confirmSignOutAll: 'Are you sure you want to sign out on all devices?',
    signOutAllShort: 'Sign out all devices',
    passwordRequired: 'Password required',
    deleteThisAcc: 'Delete this account',
    deleteThisProf: 'Delete this profile',
    confirmDeleteAcc: 'Are you sure you want to delete this account?',
    confirmDeleteProf: 'Are you sure you want to delete this profile?',
    changeEmailAddress: 'Change email address',
    currentEmail: 'Current email',
    newEmail: 'New email',
    currentPassword: 'Current password',
    updateEmail: 'Update email',
    verifyingPlease: 'Verifying email address, please wait.',
    verifyingEmailMessage:
      'Thanks for taking the time to confirm your email address.<br> Your registration with My S4C is now complete.',
    pleaseLogin:
      "Please <a href='/MyS4C/SignIn'>sign in</a> again with the new email address.",
    verifyEmail: 'Verify email',
    emailSoon:
      'You will receive an email soon with a link to confirm your email address and activate your account.',
    updateSuccess: 'Update successful',
    addSuccess: 'Add successful',
    emailResetPassword:
      'You will shortly receive an email containing instructions on how to reset your password',
    newPassword: 'New password',
    updatePassword: 'Update password',
    updatePasswordSuccess: 'Password successfully updated',
    problemCompleting:
      'There has been a problem completing this action, please try again',
    communicationPreferences: 'Communication preferences',
    updatePreferences: 'Update preferences',
    availability: 'Availability',
    shareEmail: 'Share via email',
    shareFacebook: 'Share on Facebook',
    shareTwitter: 'Share on Twitter',
    shareWhatsapp: 'Share on Whatsapp',
    close: 'Close',
    resetMyPassword: 'Reset my password',
    forgottenPassword: 'Forgotten password',
    forgotPasswordIntstruct:
      "Enter your email address and we'll send you further instructions.",
    playerErrorDetected: 'Error',
    adBlockerDetected: 'Ad Blocker detected',
    adBlockerMsg1:
      'Please disable your ad blocker and refresh this page to view our content.',
    adBlockerMsg2:
      'Please bear in mind that advertising revenue goes toward content creation.',
    playAnyway: 'Continue',
    notAutoplayNextProgramme: 'Do not autoplay next programme',
    todaysHighlights: "Today's Highlights",
    yesterdaysHighlights: "Yesterday's Highlights",
    yesterday: 'Yesterday',
    highlights: 'Highlights',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    todayAt: 'Today at',
    today: 'Today',
    at: 'at',
    tonightAt: 'Tonight at',
    showMore: 'Show more',
    allGenres: 'All genres',
    OurChannelForKids: 'Our channel for kids aged 0-6',
    programmesForTeenagers: 'Programmes for 7–13 year olds',
    notAvailable: 'Not available',
    next: 'Next',
    recommended: 'Recommended',
    enterFour: 'Enter a 4 digit PIN',
    confirmPin: 'Confirm your PIN',
    askForPin: 'Ask for your PIN for every programme with a content warning?',
    emailAddressPin:
      'Email address (used to send your PIN to you if you forget it)',
    enableParent: 'Enable parental control',
    disableParent: 'Disable parental control',
    setPin: 'Set pin',
    removePin: 'Remove pin',
    parentNotSet:
      "<p><b>Parental control is currently not set.</b> This means any one using this browser is able to view programmes that may contain content that's unsuitable for children.</p><p>You can prevent this by setting up a PIN allowing you to manage the parental control settings for this account.</p><p>If enabled you will be asked to enter a PIN every time this account watches a programme that has a content warning. If parental control is disabled, you won't be asked each time to enter a PIN if you're over 16.</p>",
    noMatchPins: 'PINs do not match',
    pinFour: 'PIN needs to be 4 digits',
    digit1: 'First PIN digit',
    digit2: 'Second PIN digit',
    digit3: 'Third PIN digit',
    digit4: 'Fourth PIN digit',
    newDigit1: 'First new PIN digit',
    newDigit2: 'Second new PIN digit',
    newDigit3: 'Third new PIN digit',
    newDigit4: 'Fourth new PIN digit',
    confDigit1: 'First PIN digit confirm',
    confDigit2: 'Second PIN digit confirm',
    confDigit3: 'Third PIN digit confirm',
    confDigit4: 'Fourth PIN digit confirm',
    on: 'On',
    off: 'Off',
    parentSetOn: 'Parental control is currently enabled.',
    parentSetOnDesc:
      'You will be asked to enter a PIN everytime this account watches a programme that has a content warning.',
    parentSetOff: 'Parental control is currently disabled.',
    parentSetOffDesc:
      "You won't be asked to enter a PIN when this account watches a programme that has a content warning.",
    parentControlSettings: 'Parental control Settings',
    yourPin: 'Your PIN',
    updateParentControl: 'Update parental control',
    changePin: 'Change PIN',
    yourCurrentPin: 'Your current PIN',
    enterPin: 'Enter PIN',
    enterNewPin: 'Enter a new PIN',
    confirmNewPin: 'Confirm your new PIN',
    updatePin: 'Update PIN',
    forgottenPin: 'Forgotten PIN?',
    incorrectPin: 'PIN supplied does not match',
    pinChangeSuccess: 'PIN change successful',
    contentWarning: 'Content Warning',
    contentWarningTitle: 'Content Warning',
    contentWarningChallenge:
      'Please verify that you are old enough to watch this programme.',
    contentWarningConfirm: 'Yes, I am 16 years or older',
    contentWarningChallengePin: 'Enter your PIN number to view the programme.',
    ok: 'Ok',
    not16: 'Unsuitable for children',
    parentalUpdated: 'Parental control has been updated',
    feedBackAlert:
      'Thank you for trying our beta version of Clic. If you have any feedback, please email us on',
    feedBackSubject: 'Clic Beta Feedback',
    dismiss: 'Dismiss',
    metaSiteName: 'S4C',
    metaTitle: 'S4C Clic',
    metaUrl: 'https://www.s4c.cymru/clic',
    metaDescription:
      'S4C Clic: The latest content, box sets from the archive, live sports, and a variety of programmes.',
    metaTwitter: '@s4c',
    signedVersion: 'Signed version',
    about: 'About',
    privacy: 'Privacy Policy',
    aboutThisApp: 'About this app',
    appVersion: 'S4C Clic version',
    resetPIN:
      'For instructions to reset your PIN, please contact our hotline on 0370 600 4141 (Calls cost no more than a national rate call to an 01 or 02 number) or email us at gwifren@s4c.cymru.',
    programmes: 'Programmes',
    selectProfileImg: 'Choose a profile image',
    isChildAccount: 'Child account',
    edit: 'Edit',
    add: 'Add',
    profileSetSuccess: 'Current active profile updated to',
    profileDeleteSuccess: 'Profile has been deleted',
    manageProfiles: 'Manage your profiles',
    addProfile: 'Add a profile',
    mainAccountText: 'This is the main account',
    hi: 'Hi',
    boxSets: 'Box Sets',
    episodesAvailable: 'Episodes available',
    episodes: 'episodes',
    englishSubtitles: 'English subtitles available',
    welshSubtitles: 'Welsh subtitles available',
    welshEnglishSubtitles: 'Welsh and English subtitles available',
    onlineExclusives: 'Online Exclusives',
    onlineExclusive: 'Online Exclusive',
    success: 'Success',
    successfullyDeleted1: 'Your account has successfully been deleted.',
    successfullyDeleted2:
      "We're sorry to see you go! If there's anything we could have done better it would be great if you could let us know. We're always looking to improve.",
    sendFeedback: 'Send feedback',
    feedbackURL: 'https://www.s4c.cymru/e_contact.shtml',
    mailingLists: [
      'Receive our updates by email to hear about S4C’s programmes and services and have your opportunity to share your views.',
      'Be the first to hear about new features on our platforms',
    ],
    choosePast: 'Please choose a date in the past',
    moreFromS4C: 'Want to get more from S4C Clic?',
    signUpNow: 'Sign up now',
    editProfile: 'Edit profile',
    alreadyRegistered: 'Already registered?',
    dobPlaceHolder: 'DD/MM/YYYY',
    tryCat: 'Why not try something from one of our categories?',
    genericError: 'Sorry, an error has occurred',
    channels: 'Channels',
    hanshDesc: 'Tunes, comedy and fresh faces',
    progSignUpTitle: 'You need to sign in to watch this',
    progSignUpInstruction: 'It should only take a few minutes',
    or: 'or',
    loginIsComing: 'Get more from S4C Clic',
    willNeedToLogin: 'By 10 June you’ll need to register to watch S4C Clic.',
    signingInAllows: 'Sign up now to...',
    createProfiles: 'Create profiles for your family',
    createList: 'Create your own list of programmes',
    continueWatching: 'Continue watching where you left off',
    daysToLogin: 'days to go',
    dayToLogin: 'day to go',
    loginToWatch: 'You need to sign in to watch',
    loginOnce: 'But you only need do it once to continue enjoying S4C Clic',
    back: 'Back',
    createAccount: 'Create an account',
    competitionMessage:
      "Register between May 27 and August 10 for the chance to win a 49” Widescreen Smart TV. <a href='https://www.s4c.cymru/clic-competition' target='_blank'>Terms and conditions</a>",
    audioDescribed: 'Audio described',
    signed: 'Signed',
    otherCommsVailable: "Mae'r darllediad hwn ar gael yn y Gymraeg",
    learnersChannel: 'Learners',
    learnersDesc: 'Programmes for Welsh Learners',
    walterChannel: 'Walter Presents',
    walterDesc: 'Ar gyfer S4C',
    podcasts: 'Podcasts',
    manageList: 'Manage list',
    SignUpForLatest: 'Sign up for the latest news from S4C',
    deeplLinkLabel: 'Use the App',
    didYouMean: 'Did you mean',
    didYouMeanQ: 'Did you mean?',
    updateYourDetails: 'Update your details',
    moreDataMsg1:
      'To help us improve S4C Clic, we need a few details about you.',
    moreDataMsg2:
      'We won’t share them with anyone – we just want to make sure that we’re giving you the best programmes, as and when you want them.',
    code: 'Code',
    connect: 'Connect',
    connectTV: 'Connect your account with your TV',
    enterTVCode: 'Enter your code as shown on your TV',
    successTVCode: 'Your code has been processed',
    invalidCode: 'Please supply a valid code',
    catchUpInValidDate: 'There are no programmes for this date.',
    whosWatching: "Who's watching?",
    day: 'Day',
    month: 'Month',
    year: 'Year',
    dd: 'dd',
    mm: 'mm',
    yyyy: 'yyyy',
    searchLookingFor: 'If you are looking for',
    searchYouMighLike: ' you might like...',
    searchYouMighLikeFrom: ' you might like something from',
    searchAll: 'All',
    searchProgrammes: 'programmes',
    hereForYou: 'Clic Advent Calendar',
    hereForYouDesc: 'A Present from S4C to you',
    suggestions: 'Suggestions',
    lookingFor: 'Are you looking for',
    tryACategory: 'Or why not try exploring our categories?',
    whereShare: 'Where would you like to share this content?',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    currentTheme: 'Current theme',
    searchClic: 'Search Clic',
    optional: 'Optional',
    appearance: 'Appearance',
    viewAll: 'View all',
    error404: '404 Error',
    error404CantFindPage: `Sorry, we can't find this page`,
    error404Desc: `Don't worry, have a look at all of our categories and find content that you love`,
    error404BrowseCategories: 'Browse categories',
    error404TakeMeHome: 'Take me home',
    moreDetails: 'More details',
    closeDetails: 'Less details',
    keyboardShortcuts: 'Keyboard shortcuts',
    toggleWelsh: 'Toggle Welsh Subtitles on/off',
    toggleEnglish: 'Toggle English Subtitles on/off',
    skip5Sec: 'Skip back 5 seconds',
    fastForward5Sec: 'Skip forward 5 seconds',
    pauseVideo: 'Pause video',
    followS4CFacebook: 'Follow S4C on Facebook for more content',
    followS4CInstagram: 'Follow S4C on Instagram for more content',
    followS4CTwitter: 'Follow S4C on Twitter for more content',
    followS4CYoutube: 'Watch more S4C content on YouTube',
    profileDropdown: 'Profile dropdown',
    profileAvatar: 'Profile avatar',
    metaDescriptionBoxsets:
      'From old series and films to brand new programmes, we have box sets for everyone here.',
    metaDescriptionCategories:
      'Sports, drama, entertainment and more – watch content across a wide range of categories.',
    metaDescriptionCatchUp:
      'Haven’t had the opportunity to watch something yet? Here’s the place to catch-up on recently released content.',
    metaDescriptionLive:
      'Watch S4C’s live content here – from live sports to Cyw content.',
    metaDescriptionSearch:
      'Can’t find the content that you wanted to watch? Use our search feature to find the content for you.',
    nowAndNext: 'Now and next',
    popular: 'Popular',
    trending: 'Trending',
    topPicks: 'For you',
    ourPicks: 'Our picks',
    popularThisWeek: 'Popular this week',
    trendingNow: 'Trending now',
    contentUnsuitableForChildren:
      "This content isn't suitable for a child profile.",
    upNext: 'Up next',
    play: 'Play',
    playingIn: 'Playing in',
    seconds: 's',
    expired: 'Expired',
    streamNotFound: "Sorry, this stream isn't available.",
    expires: 'Expires',
    streamNotAvailableForCatchUp: 'Stream not available for catch up',
    streamNoLongerAvailableForCatchUp:
      'Stream no longer available for catch up',

    // Error messages from MyS4C.pl
    '00000': 'Either the email address or the password is incorrect',
    '00001': 'This account temporarily locked, please try again later',
    '00002': "You haven't entered all the information we need",
    '00003': 'Client Device ID must be provided',
    '00004':
      'Sorry, the system is being updated. This usually takes just a few minutes. If you are still having a problem please contact us',
    '00005': "The email address you've entered isn't valid",
    '00006':
      'You have previously asked us not to send any e-mails to your address.  Unfortunately this means you will not be able to register for MyS4C.  If you want to change this please contact the Viewers Hotline on 0370 600 4141',
    '00007': 'That email address has already been used.',
    '00008':
      'That account is currently in the process of being deleted, it will be available for registration again shortly',
    '00009':
      'You cannot subscribe to newsletters at this time as you have previously asked us not to send any e-mails to your address. If you want to change this please contact the Viewers Hotline on 0370 600 4141',
    '00010': 'The password must contain at least 6 characters',
    '00011': "The passwords you've entered do not match",
    '00012': "Something's gone wrong. <a href='/MyS4C/SignUp'>Start again.</a>",
    '00013': 'This account temporarily locked, please try again later',
    '00014':
      "There's been a problem, <a href='/MyS4C/SignIn'>please login again.</a>",
    '00015': 'This account is locked',
    '00016': 'This account is waiting to be verified',
    '00017': "We can't find the account you're trying to login to.",
    '00018':
      "There's been a problem with the login on this device, <a href='/MyS4C/SignIn'>Please login again.</a>",
    '00019':
      "This session is no longer valid,  <a href='/MyS4C/SignIn'>Please login again.</a>",
    '00020': 'Please log in as main account holder to do this',
    '00021': 'You do not have permission to access this account',
    '00022':
      'Please log in as the main account holder to choose a different account',
    '00023': 'You do not have permission to view this account',
    '00024':
      'If you want to provide your birth date you must provide day, month and year',
    '00025': 'That is not a valid date of birth',
    '00026':
      'Cannot use that name, there is already a child with that name listed on your account',
    '00027': 'You need to enter an email address',
    '00028': "The email address you've entered isn't valid",
    '00029': 'That email address has already been used',
    '00030':
      "Something's gone wrong while validating your email address. <a href='/MyS4C/SignIn'>Please try again.</a>",
    '00031': 'Sorry, we are unable to find that email address',
    '00032': 'E-mail address and/or validation code is incorrect.',
    '00033': 'That email address has already been verified',
    '00034': `Sorry, the password is too long. It can't be more than ${PASSORD_MAX_CHARACTERS} characters`,
    99999: 'The password is incorrect',
    20001: 'Profile does not exist',
    20002: 'That profile no longer exists',
    20003: 'Maximum of 10 profiles per account allowed',
    20004: 'You cannot delete this profile as it belongs to the account holder',
    20005: 'New and confirmation passwords do not match',
    20006:
      'Unable to change password, are you sure the password you entered is correct?',
    20007: 'Incorrect password',
    20008: 'Must select a profile first',
    20009: 'Code not available or may have expired',
    30000: 'item_name is not valid',
    30001: 'Code is missing',
    30002: 'socket_id is missing',
    30003: 'advertising_id is missing',

    // Error Messages For Smart TV broadcast
    'We were unable to connect to the device, please try again.':
      'We were unable to connect to the device, please try again.',
    footerSearch: 'Looking for something else?',
    footerSearchPlaceholder: 'Search for a programme or genre',
  },
];
